<template>
  <div class="dropdown-menu">
    <template v-if="items.length">
      <button
        :class="{ 'is-selected': index === selectedId }"
        v-for="(item, index) in items"
        :key="index"
        @click="selectItem(item, index)"
      >
        <p v-if="item.name">
          {{ item.name }}
        </p>
      </button>
    </template>
    <div class="item" v-else>{{ "Sem dados" }}</div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },

    command: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      selectedIndex: 0,
    };
  },

  watch: {
    items() {
      this.selectedIndex = 0;
    },
  },

  methods: {
    onKeyDown({ event }) {
      if (event.key === "ArrowUp") {
        this.upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        this.downHandler();
        return true;
      }

      if (event.key === "Enter") {
        this.enterHandler();
        return true;
      }

      return false;
    },

    upHandler() {
      this.selectedIndex =
        (this.selectedIndex + this.items.length - 1) % this.items.length;
    },

    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
    },

    enterHandler() {
      this.selectItem(this.items[this.selectedIndex], this.selectedIndex);
    },

    selectItem(item, index) {
      if (!item && !item.name) return;
      this.selectedId = index;
      this.command({ name: item?.name, id:item?.id});
    },
  },
};
</script>

<style lang="scss">
.dropdown-menu {
  background: white;
  border: 1px solid #ededed;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  overflow: auto;
  padding: 0.4rem;
  position: relative;
  @apply text-h-primary-800 min-w-[150px];

  button {
    align-items: center;
    background-color: transparent;
    display: flex;
    gap: 0.25rem;
    text-align: left;
    width: 100%;
    padding: 0.3rem;

    &:hover,
    &:hover.is-selected {
      background-color: rgb(242, 242, 242);
      border-radius: 0.5rem;
    }

    &.is-selected {
      background-color: rgb(228, 228, 228);
      border-radius: 0.5rem;
    }
  }
}
</style>
